// Discounted price shown inline: original (struck) → new price (red) + red "خصم X%" badge.
export function OfferPrice({ o, testid, lang }) {
  return (
    <span className="inline-flex items-center gap-1.5 flex-wrap" data-testid={testid}>
      <s className="text-xs text-slate-400 font-semibold whitespace-nowrap" data-testid={testid && `${testid}-original`}>{o.original}</s>
      <span className="text-slate-400 text-xs">{lang === "en" ? "→" : "←"}</span>
      <b className="text-[#1A5C3A] whitespace-nowrap" data-testid={testid && `${testid}-price`}>{o.price}</b>
      <span className="bg-red-600 text-white text-[11px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap" data-testid={testid && `${testid}-badge`}>{o.disc}</span>
    </span>
  );
}

// Builds the offer value object used by detail rows ({offer, price, original, disc, text}).
export function offerValue(off, fmt, lang) {
  const price = fmt(off.price), original = fmt(off.original);
  const disc = lang === "en" ? `${off.pct}% off` : `خصم ${off.pct}%`;
  return { offer: true, price, original, disc, text: `${original} ${lang === "en" ? "→" : "←"} ${price} (${disc})` };
}
